<div class="firstDiv"><h5 class="ShippingHeading">Return & Refund Policy</h5></div>

<div  class="secondDiv">
    <p class="shippingPara">At FRRANKY, we believe in creating a great shopping experience for our customers. If you're not satisfied with your order, we're here to make it right. Please review our Return and Refund Policy below.<br>
    </p><h5 class="SubHeadings">
    1.  Return Eligibility</h5>
   <p class="para">You may return your order under the following conditions:
    A return request is initiated within 7 days of receiving the product.
    The product is unused, unwashed, unaltered, and in its original condition with all tags, labels, and packaging intact.


    A valid order confirmation and invoice must be provided.
    
    
    The product is not from the NON-RETURNABLE category such as:
    
    
    Final Sale / Clearance items
    Customized or personalized products</p>
    
    
    <h5 class="SubHeadings">2.  How to Initiate a Return</h5>
    <p class="para">To request a return:
        Email us at support@frranky.com or WhatsApp our support at +91-XXXXXXXXXX within 7 days of delivery.
        
        
        Insert your order ID, and reason for return
        
        
        Our support team will review and confirm your request within 1–2 business days.
        
        
        Once approved, we will arrange for a reverse pickup (if serviceable), or request you to self-ship the product.</p>
    
   <h5 class="SubHeadings">3. Return Shipping Process</h5> 
   <p class="para">Reverse Pickup: Available in most locations. Scheduled within 3–4 business days after approval.


    Self-Shipping: If reverse pickup isn’t available in your area, you may courier the product to our return address. Shipping cost for self-ship returns (for valid cases) may be reimbursed up to ₹100 in the refund.
    
    
   <h5 class="SubHeadings">4. Refund Process</h5> 
   <p class="para">Once we receive the returned item and it passes the quality inspection, we will initiate your refund. Here are the options:
    Prepaid Orders: Amount will be refunded to the original payment method (e.g.: UPI) within 5–7 business days.
    Cash on Delivery Orders: Only eligible for refund on Defective products.

    Note: If the returned product fails the quality check (e.g., used, damaged, worn), the return will be rejected, and the item will be shipped back to you.
    </p>
    
    
   <h5 class="SubHeadings">5.Exchange Policy</h5>
   <p class="para">We offer free size or product exchanges if:
    The product is still in stock
    
    
    The exchange request is made within 7 days of delivery
    
    
    The returned product meets quality check standards
    
    
    You can exchange your product once per order. In case the desired item is unavailable, we will issue a refund.</p>
    
    
    
    <h5 class="SubHeadings">6. Non-Returnable Items</h5>
    <p class="para">The following items are not eligible for return, refund, or exchange:
        Worn or washed products
        
        
        Items without original packaging and tags
        
        
        Clearance sale or discounted items (unless defective)
        
        
        Customized, personalized, or made-to-order products
        </p>
    
        <h5 class="SubHeadings">7.Defective Products</h5>
        <p class="para">If you receive a defective item:
            Contact us within 48 hours of delivery.
            
            
            Share an unboxing video with clear pictures and a description of the issue.
            
            
            Once verified, we’ll either replace the product at no extra cost or process a full refund. </p>
          <h5 class="SubHeadings">8. Late or Missing Refunds</h5>
          <p class="para">If you haven’t received your refund after 7 business days:
            Recheck your bank/UPI account or payment app
            
            
            Contact your payment provider or bank.
            If unresolved, email us at support@frranky.com with your order ID and refund details</p>
            <h5 class="SubHeadings">9. Cancellation Policy</h5>
            <p class="para"> Orders can be canceled within 24 hours of placing the order


                Once shipped, the order cannot be canceled but may be returned after delivery (if eligible).
                    </p>
    
    
   <h5 class="SubHeadings">10. Contact Us</h5>
   <p class="para">  If you have questions about returns, exchanges, or refunds, reach out to us:
     📧 Email: support@frranky.com<br>
     📞 Phone/WhatsApp: +91-9811308821<br>
     📍 Return Address: C-484, Second Floor, Saraswati Vihar, Pitampura, New Delhi-110034<br>
     FRRANKY’s Promise
     We stand behind every product we create. If something’s not right, we’ll fix it — because you don’t just wear FRRANKY, you believe in it.</p>
    </div>
    
